export default "__VITE_PUBLIC_ASSET__bec27781__"